import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sentinel", "link"]

  connect() {
    this.loading = false
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) this.loadMore()
      })
    }, { rootMargin: "200px" })
    if (this.hasSentinelTarget) this.observer.observe(this.sentinelTarget)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  loadMore() {
    if (!this.hasLinkTarget || this.loading) return
    this.loading = true
    this.linkTarget.click()
  }

  sentinelTargetConnected(element) {
    this.loading = false
    this.observer?.disconnect()
    this.observer?.observe(element)
  }
}
